export default "__VITE_ASSET__CcC$jElp__"